import { useDispatch } from 'react-redux';
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { debounce, set } from 'lodash';
import { ordersApi } from '../../services/OrderService';
import { fetchTrackingStatuses } from '../../api/trackingApi';
import TrackingStatus from '../../components/TrackingFormatter';
// import profileReducer from './profileSlice';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import { Table, Card, CardBody, CardHeader, Col, Container, Button, Row, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, InputGroup, Badge, Alert } from 'reactstrap';
import { AvForm, AvField, AvCheckboxGroup, AvCheckbox } from 'availity-reactstrap-validation';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import FilterDropdown from '../../components/Filter/FilterDropdown';
import { Link2, Banknote } from 'lucide-react';
import Flatpickr from 'react-flatpickr';
import NumberFormat from 'react-number-format';
import Breadcrumbs from '../../components/Breadcrumb';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import filterFactory, { textFilter, selectFilter, dateFilter } from 'react-bootstrap-table2-filter';
import InputMask from 'react-input-mask';
import { Search } from 'react-bootstrap-table2-toolkit';
import Dropzone from 'react-dropzone';
import { Dropdown } from 'semantic-ui-react';
import { ExternalLink, Copy } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// Helpers
import { countryOptions, usStateOptions } from '../../helpers/country_helper';
import { defaultDiacriticsRemovalMap } from '../../helpers/ascii_helper';
import { getScreenHeight } from '../../utils/getScreenHeight';
import { showToast } from '../../components/Toast';
import TrackingColumn from '../../components/TrackingColumn';
import '@fullcalendar/bootstrap/main.css';
import PageLoader from '../../components/Loaders/newPageLoader';
import BtnLoader from '../../components/Loaders/btnLoader';
import SweetAlert from 'react-bootstrap-sweetalert';
import MyExportCSV from '../../components/exportCSV';
import useLoadingProgress from '../../hooks/useLoadingProgress';
import { MainContent } from '../../components/Table/MainContent';
import { BtnModal } from '../../components/Table/BtnModal';

import { LIVE_LINK } from '../../helpers/url_helper';

export default function ClientOrder({ profileData, loading }) {
  const {
    data = [],
    isLoading,
    isFetching,
    // error,
    refetch
  } = ordersApi.useFetchAllOrdersQuery(profileData._id, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false
  });

  const [getOrders, { data: filteredData }] = ordersApi.useLazyFetchAllOrdersQuery();
  const [addOrder] = ordersApi.useAddOrderMutation();
  const [generatePaymentRequest] = ordersApi.useGeneratePaymentRequestMutation();
  const [updateOrder] = ordersApi.useUpdateOrderMutation();
  const [deleteOrder] = ordersApi.useDeleteOrderMutation();

  const [getInvoiceNumber] = ordersApi.useGetNextInvoiceNumberMutation();

  const [orders, setOrdersData] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState(null);
  const [filters, setNoDbFilters] = useState([]);
  const [accessToken, setAccessToken] = useState(null);
  const [order, setOrder] = useState({ invoiceNo: '' });
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [managers, setManagersData] = useState([]);
  const [categories, setCategoriesData] = useState([]);
  const [languages, setLanguagesData] = useState([]);
  const [countries, setCountriesData] = useState([]);
  const [period, setPeriodData] = useState([]);
  const [isChecked, setChecked] = useState(true);
  const [error, setErrorMsg] = useState('');

  const [expDef, setExpDef] = useState('');
  const [expCont, setExpCont] = useState('');
  const [expCntr, setExpCntr] = useState('');
  const [expSt, setExpSt] = useState('');
  const [expCt, setExpCt] = useState('');
  const [expLng, setExpLng] = useState('');

  const [assProductsChecked, setAssProductsChecked] = useState(false);
  const [noAssProductsChecked, setNoAssProductsChecked] = useState(true);
  const [includeWAmountChecked, setIncludeWAmountChecked] = useState(false);
  const [includeWAmountAddChecked, setIncludeWAmountAddChecked] = useState(false);

  const [modalOrder, setOrderModal] = useState(false);
  const [modalPayment, setPaymentModal] = useState(false);
  const [modalInfo, setInfoModal] = useState(false);
  // const [option, setOption] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  // const [isFiltering, setIsFiltering] = useState(false);

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const { progress, step, visible } = useLoadingProgress({ isLoading, isFetching });
  useEffect(() => {
    const newData = filteredData ?? data;
    if (!newData) return;

    const { orders = [], managers = [], categories = [], languages = [], countries = [], period = {}, accessToken = {} } = newData;

    setOrdersData((prev) => (JSON.stringify(prev) !== JSON.stringify(orders) ? [...orders] : prev));
    setManagersData((prev) => (JSON.stringify(prev) !== JSON.stringify(managers) ? [...managers] : prev));
    setCategoriesData((prev) => (JSON.stringify(prev) !== JSON.stringify(categories) ? [...categories] : prev));
    setLanguagesData((prev) => (JSON.stringify(prev) !== JSON.stringify(languages) ? [...languages] : prev));
    setCountriesData((prev) => (JSON.stringify(prev) !== JSON.stringify(countries) ? [...countries] : prev));
    setPeriodData((prev) => (prev !== period ? period : prev));
    setAccessToken((prev) => (prev !== accessToken?.variableValue ? accessToken?.variableValue : prev));
  }, [JSON.stringify(data), JSON.stringify(filteredData)]);

  const [cardHeight, setCardHeight] = useState(0);
  const cardRef = useRef(null);
  useEffect(() => {
    if (!cardRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const newHeight = entry.contentRect.height;
        if (newHeight > 0) setCardHeight(newHeight);
      }
    });
    resizeObserver.observe(cardRef.current);
    return () => resizeObserver.disconnect();
  }, []);
  console.log(data);
  useEffect(() => {
    const applyFilters = () => {
      let result = [...orders];

      if (filters?.orderTypes?.length > 0) {
        const allowedValues = filters.orderTypes;
        result = result.filter((order) => allowedValues.includes(order.paymentLinkCreated));
      }

      // if (filters?.accountTypes?.length > 0) {
      //   result = result.filter(user => filters?.accountTypes.includes(user.accType));
      // }
      setFilteredOrders(result);
    };

    applyFilters();
  }, [filters, orders]);
  /**
   * Toggles the checked state and fetches orders based on the new state.
   * If checked, fetches orders for the current profile; otherwise, fetches all orders.
   *
   * @async
   * @param {React.SyntheticEvent} e - The event object triggered by the user action.
   */
  const showAllOrders = async (e) => {
    setChecked((prev) => {
      const newChecked = !prev;
      const id = newChecked === true ? profileData._id : 'all';
      getOrders(id);
      return newChecked;
    });
  };
  /**
   * Toggles the visibility state of the order modal.
   * Uses a callback to invert the current modal state.
   *
   * @function
   * @returns {void}
   */
  const toggleOrderModal = useCallback(() => {
    setOrderModal((prev) => !prev);
  }, []);
  /**
   * Toggles the visibility state of the payment modal.
   * Uses a callback to invert the current modal state.
   *
   * @function
   * @returns {void}
   */
  const togglePaymentModal = useCallback(() => {
    setPaymentModal((prev) => !prev);
  }, []);
  /**
   * Toggles the visibility state of the info modal.
   * Uses a callback to invert the current modal state.
   *
   * @function
   * @returns {void}
   */
  const toggleOrderInfoModal = useCallback(() => {
    setInfoModal((prev) => !prev);
  }, []);
  /**
   * Handles the logic for initiating a new order when the user clicks the "New Order" button.
   * This function resets relevant state variables, toggles the order modal, fetches a new invoice number,
   * and sets default values for various order-related options and checkboxes.
   *
   * @async
   * @returns {Promise<void>} Resolves when the new invoice number is fetched and state is updated.
   */
  const handleNewOrderClick = async () => {
    toggleOrderModal();
    setErrorMsg('');
    setIsEdit(false);
    // setOption(option);
    setExpDef('');
    setExpCont('');
    setExpCntr('');
    setExpSt('');
    setExpCt('');
    setExpLng('');
    const newInvoiceNo = await getInvoiceNumber().unwrap();
    setOrder({ invoiceNo: newInvoiceNo });
    setAssProductsChecked(false);
    setNoAssProductsChecked(true);
    setIncludeWAmountChecked(false);
    setIncludeWAmountAddChecked(false);
  };

  const handleNewPaymentClick = async (e, order) => {
    if (!accessToken || accessToken === '') {
      const redirectUri = encodeURIComponent(process.env.REACT_APP_REDIRECT_URI);
      console.log(redirectUri);
      const scope = 'read write';
      const responseType = 'code';
      const url = `https://login.payoneer.com/api/v2/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${responseType}`;
      console.log(process.env.REACT_APP_CLIENT_ID);
      console.log(url);
      window.open(url, '_blank');
    } else {
      togglePaymentModal();
      setErrorMsg('');
      setIsEdit(false);
      if (!order) {
        const newInvoiceNo = await getInvoiceNumber().unwrap();
        setOrder({ invoiceNo: newInvoiceNo });
      } else {
        setOrder(order);
      }
    }
  };

  const handleEditOrderClick = (orderData) => {
    setOrder(orderData);
    // setOption(option);
    setSelectedCountry(orderData.country);
    setExpDef(orderData.currency);
    setExpCont(orderData.country);
    setExpCntr(orderData.country);
    setExpSt(orderData.country);
    setExpCt(orderData.country);
    setExpLng(orderData.language);

    setAssProductsChecked(orderData.excludeAssProducts && false);
    setNoAssProductsChecked(orderData.excludeAssProducts);
    setIncludeWAmountChecked(orderData.includeWPrice);
    setIncludeWAmountAddChecked(orderData.includeAddWPrice);

    setIsEdit(true);
    toggleOrderModal();
  };

  const handleOrderComplete = (orderData) => {
    const updatedOrder = {
      _id: orderData._id,
      orderStatus: !orderData.orderStatus
    };
    updateOrder(updatedOrder);
  };

  const handleViewOrderInfo = (orderData) => {
    setOrder(orderData);
    toggleOrderInfoModal();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    if (name === 'expDef') {
      setExpDef(value);
      setExpLng(value === '' ? '' : value === 'cny' ? 'cn' : 'eng');
    } else {
      switch (name) {
        case 'expCont':
          setExpCont(value);
          break;
        case 'expCntr':
          setExpCntr(value);
          break;
        case 'expSt':
          setExpSt(value);
          break;
        case 'expCt':
          setExpCt(value);
          break;
        case 'expLng':
          setExpLng(value);
          break;
        default:
          break;
      }
    }
  };

  const handleInputChange = (value) => {
    setSelectedCountry(value);
  };
  const handleStateChange = (value) => {
    setSelectedState(value);
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const handleAcceptedFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        acceptedFiles: 'image/*',
        formattedSize: formatBytes(file.size)
      })
    );
    setSelectedFile(files);
  };
  /**
   * Formats the size
   */
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  const handleAssProductsChange = (e) => {
    const { name } = e.target;
    if (name === 'assProducts') {
      setAssProductsChecked((prev) => !prev);
      setNoAssProductsChecked(false);
    } else if (name === 'noAssProducts') {
      setNoAssProductsChecked((prev) => !prev);
      setAssProductsChecked(false);
    } else if (name === 'includeWAmount') {
      setIncludeWAmountChecked((prev) => !prev);
    } else if (name === 'includeWAmountAdd') {
      setIncludeWAmountAddChecked((prev) => !prev);
      setIncludeWAmountChecked((prev) => !prev); // use `prev` to toggle based on previous state
    }
  };

  const handleNewOrderSubmit = async (e, values) => {
    if (isEdit) {
      const updatedOrder = {
        _id: order._id,
        //first row
        invoiceNo: values.invoiceNo,
        clientName: values.clientName,
        manager: values.manager.split('|')[0],
        //second row
        currency: values.expDef,
        country: values.expCont || values.expCntr || values.expSt || values.expCt,
        language: values.expLng,
        categories: values.expCat,
        includeWPrice: includeWAmountChecked,
        includeAddWPrice: includeWAmountAddChecked,
        excludeAssProducts: assProductsChecked ? false : noAssProductsChecked
      };
      updateOrder(updatedOrder);
    } else {
      const newOrder = {
        //first row
        invoiceNo: values['invoiceNo'],
        clientName: values['clientName'],
        manager: values['manager'].split('|')[0],
        // second row
        currency: values['expDef'],
        country: values['expCont'] || values['expCntr'] || values['expSt'] || values['expCt'],
        language: values['expLng'],
        categories: values['expCat'],
        includeWPrice: includeWAmountChecked,
        includeAddWPrice: includeWAmountAddChecked,
        excludeAssProducts: assProductsChecked ? false : noAssProductsChecked,
        // hidden data
        startDate: period.startDate,
        year: period.year,
        month: period.month
      };
      addOrder(newOrder);
    }
    setOrder([]);
    setIsEdit(false);
    toggleOrderModal();
  };

  const handleNewPaymentLinkSubmit = async (e, values) => {
    e.preventDefault();
    if (!selectedFile) {
      alert('Please upload a PDF file.');
      return;
    }
    const description = `${values['oneCNo']} ${(() => {
      const m = managers.find((m) => m._id === values['manager'].split('|')[0]);
      return m ? `, ${m.fname[0]}${m.sname[0]}${m.sname.match(/\d+/)?.[0] || ''}` : '';
    })()}`;
    const payoneerData = {
      amount: values['invoiceSum'],
      currency: values['currencyReq'],
      client_reference_id: `payment_id_${values['invoiceNo']}_${new Date().toISOString().replace(/[:.]/g, '-')}`,
      description: description,
      // website: values['website'],
      payer_details: {
        type: 'COMPANY',
        company: {
          name: values['clientName'],
          url: values['link']
        },
        contact: {
          first_name: values['clientFName'],
          last_name: values['clientSName'],
          phone: '',
          phone_country: '',
          email: values['email']
        }
      },
      address: {
        country: selectedCountry,
        state: selectedState
      },
      fee_pay_by: 'payer',
      payment_due_date: new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10)
    };
    const dbData = {
      accessToken: accessToken,
      clientReferenceId: `payment_id_${values['invoiceNo']}_${new Date().toISOString().replace(/[:.]/g, '-')}`,
      id: order._id || null,
      invoiceNo: values['invoiceNo'],
      manager: values['manager'].split('|')[0],
      clientFName: values['clientFName'],
      clientSName: values['clientSName'],
      email: values['email'],
      clientName: values['clientName'],
      link: values['link'],
      country: selectedCountry,
      state: selectedState,
      oneCNo: values['oneCNo'],
      invoiceSum: values['invoiceSum'],
      paymentLinkCreated: true,
      startDate: period.startDate,
      year: period.year,
      month: period.month
    };
    // Create a FormData object
    const formData = new FormData();
    // Append the file
    formData.append('file', selectedFile);
    // Append the payload as JSON string
    formData.append('payoneerData', JSON.stringify(payoneerData));
    formData.append('dbData', JSON.stringify(dbData));
    // generatePaymentRequest(formData)
    // togglePaymentModal();
    try {
      const response = await generatePaymentRequest(formData).unwrap();
      togglePaymentModal();
      setOrder({});
    } catch (error) {
      setErrorMsg(error?.data ? error.data.errors[0].message : error);
      console.error('Failed to create payment link:', error.data.errors[0].message);
    }
  };

  const copyToClipboard = async () => {
    if (order?.orderInfo?.length === 0) {
      showToast('error', 'No data selected to copy!');
      return;
    }
    const orderDetails = order?.orderInfo;
    // Format data for clipboard
    // const textToCopy = orderDetails.map((detail) => `${detail.nomenclatureCode.split('_')[0]}\t\t${detail.title}\t\t${detail.quantity}\t${detail.unitPrice}`).join('\n');
    const textToCopy = orderDetails
      .filter((detail) => detail.unitPrice !== 0)
      .map((detail) => `\t${detail.nomenclatureCode.split('_')[0]}\t\t${detail.title}\t\t${detail.quantity}\t${detail.unitPrice}`)
      .join('\n');
    // Create a temporary textarea element
    const textarea = document.createElement('textarea');
    textarea.value = textToCopy;
    textarea.style.position = 'fixed'; // Prevent scrolling issues
    textarea.style.opacity = 0; // Hide element
    document.body.appendChild(textarea);
    textarea.select();
    try {
      if (document.execCommand('copy')) {
        showToast('Copied to clipboard'); // ✅ Success message
      } else {
        showToast('Failed to copy data.');
      }
    } catch (err) {
      showToast('Failed to copy data.');
    }
    document.body.removeChild(textarea); // Cleanup
  };

  const rowClasses = (row, rowIndex) => {
    let classes = null;
    if (row.orderInfo) {
      classes = 'alert-primary';
    }
    if (row.paymentLinkCreated === true) {
      classes = 'alert-success';
    }
    return classes;
  };
  /**
   * Handles the click event for deleting an order.
   * Sets the ID of the order to be deleted and displays the delete confirmation alert.
   *
   * @param {string|number} id - The unique identifier of the order to delete.
   */
  const handleDeleteOrderClick = (order) => {
    setOrder(order);
    setRowToDelete(order._id);
    setShowDeleteAlert(true);
  };
  /**
   * Handles the deletion of an order.
   *
   * This asynchronous function attempts to delete an order using the provided order ID and user ID.
   * On successful deletion, it updates the local orders data, displays a success toast notification,
   * and resets relevant UI state. If the deletion fails, it logs the error and shows an error toast notification.
   *
   * @async
   * @function
   * @returns {Promise<void>} Resolves when the deletion process is complete.
   */
  const handleDeleteOrder = async () => {
    try {
      await deleteOrder({
        orderId: rowToDelete,
        userId: profileData._id // coming from props
      }).unwrap();
      setOrdersData((prev) => prev.filter((order) => order._id !== rowToDelete));
      showToast('Order deleted successfully');
      setRowToDelete(null);
      setShowDeleteAlert(false);
      setOrder({});
    } catch (error) {
      console.error('Failed to delete row:', error);
      showToast('Failed to delete row', 'error');
    }
  };

  const excludedCategoryIds = ['646dad3156ed436b64227e32', '647004a0b4fb05147748ca66', '647004a8b4fb05147748ca67', '647004abb4fb05147748ca68'];
  const modalInfoContent = (
    <Col md='12' sm='12'>
      <Card>
        <CardBody>
          <div className='invoice-title'>
            <h4 className='float-end font-size-15'>
              Order Request No #{order.invoiceNo} <span className='badge bg-success font-size-12 ms-2'>{order.status}</span>
            </h4>
            <div className='mb-4'>
              <h2 className='mb-1 text-muted'>Korupharma</h2>
            </div>
          </div>
          <hr className='my-4' />
          <Row>
            <Col md='6' sm='12'>
              <div className='text-muted'>
                <h5 className='font-size-16 mb-3'>Order Request Form Sent To:</h5>
                <h5 className='font-size-15 mb-2'>{order.clientName}</h5>
                <p className='mb-1'>{order.email}</p>
              </div>
            </Col>
            <Col md='6' sm='12'>
              <div className='text-muted text-sm-end'>
                <div>
                  <h5 className='font-size-15 mb-1'>Order Request Form:</h5>
                  <p>#{order.invoiceNo}</p>
                </div>
                <div className='mt-4'>
                  <h5 className='font-size-15 mb-1'>Order Request Date:</h5>
                  <p>{new Date(order.createdAt).toLocaleString('en-GB')}</p>
                </div>
              </div>
            </Col>
          </Row>
          <div className='py-2'>
            <h5 className='font-size-15'>Order Summary</h5>
            <Table className='table text-center mt-4 ms-0 me-0 mb-4'>
              <thead>
                <tr>
                  <th style={{ width: '70px' }}>No.</th>
                  <th>Product Code</th>
                  <th>Product</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th className='text-end' style={{ width: '120px' }}>
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {order.orderInfo?.map((product, index) => {
                  return (
                    <tr key={index}>
                      <th scope='row'>
                        <div className='p-2'>{index + 1}</div>
                      </th>
                      <td>
                        <div className='p-2'>{product.nomenclatureCode.split('_')[0]}</div>
                      </td>
                      <td>
                        <div className='pt-3 pb-3'>
                          <h5 className='text-truncate font-size-14'>{product.title.replace(/\r?\n/g, ' ')}</h5>
                        </div>
                      </td>
                      <td>
                        <div className='p-2'>{product.unitPrice === 0 ? <p className='text-danger'>Provide distributor contact to client</p> : `$${product.unitPrice}`}</div>
                      </td>
                      <td>
                        <div className='p-2'>{product.quantity}</div>
                      </td>
                      <td className='text-end'>
                        <div className='p-2'>${product.totalPrice}</div>
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <th scope='row' colSpan='5' className='text-end'>
                    Sub Total
                  </th>
                  <td className='text-end'>${order.orderInfo && order.orderInfo.reduce((sum, item) => sum + item.totalPrice, 0)}</td>
                </tr>
                <tr>
                  <th scope='row' colSpan='5' className='border-0 text-end'>
                    Discount:{' '}
                  </th>
                  <td className='border-0 text-end'>- $0</td>
                </tr>
                <tr>
                  <th scope='row' colSpan='5' className='border-0 text-end'>
                    Total:{' '}
                  </th>
                  <td className='border-0 text-end'>
                    <h4 className='m-0 fw-semibold'>${order.orderInfo && order.orderInfo.reduce((sum, item) => sum + item.totalPrice, 0)}</h4>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
  const modalNewOrderContent = (
    <>
      <Row>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <AvField name='invoiceNo' label='Order Request No' type='text' autoComplete='off' value={order.invoiceNo} readOnly />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <AvField name='clientName' label='Client Name' type='text' autoComplete='off' value={order.clientName} />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className='mb-3'>
            <AvField
              type='select'
              name='manager'
              id='manager'
              className='form-select'
              label='Manager'
              errorMessage='Please select manager'
              validate={{
                required: {
                  value: true,
                  errorMessage: 'Please select manager'
                }
              }}
              value={Object.keys(order).length === 1 && order.hasOwnProperty('invoiceNo') ? profileData._id + '|' + profileData.bitrixID : order?.manager?._id + '|' + order?.manager?.bitrixID}
            >
              {managers.map((manager) => {
                return (
                  <option key={manager._id} value={manager._id + '|' + manager.bitrixID}>
                    {manager.fname} {manager.sname}
                  </option>
                );
              })}
            </AvField>
          </FormGroup>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={4}>
          <div className='text-center font-size-18 mt-2 mb-5'>
            <b>Price List with Default Prices</b>
          </div>
          <FormGroup className='mb-3'>
            <AvField
              type='select'
              name='expDef'
              className='form-select'
              label='Default Price List'
              onChange={handleFilterChange}
              disabled={expCont !== '' || expCntr !== '' || expSt !== '' || expCt !== ''}
              value={expDef}
            >
              <option value=''>Please Select Region & Currency</option>
              <option value='usd'> World (USD) </option>
              <option value='eur'> Europe (EUR) </option>
            </AvField>
          </FormGroup>
        </Col>
        <Col md={4}>
          <Row>
            <div className='text-center font-size-18 mt-2 mb-5'>
              <b>Price List with Regional Prices</b>
            </div>
            <Col md={12}>
              <FormGroup className='mb-3'>
                <AvField
                  type='select'
                  name='expCont'
                  className='form-select'
                  label='By Continent'
                  onChange={handleFilterChange}
                  disabled={expDef !== '' || expCntr !== '' || expSt !== '' || expCt !== ''}
                  value={expCont}
                >
                  <option value=''>Please Select Continent</option>
                  {countries
                    .filter((c) => c.region === 'continent')
                    .sort((a, b) => a.cntry_name.localeCompare(b.cntry_name))
                    .map((cntr, index) => {
                      return (
                        <option key={index} value={cntr.cntry_code}>
                          {cntr.cntry_name}
                        </option>
                      );
                    })}
                </AvField>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup className='mb-3'>
                <AvField
                  type='select'
                  name='expCntr'
                  className='form-select'
                  label='By Country'
                  onChange={handleFilterChange}
                  disabled={expDef !== '' || expCont !== '' || expSt !== '' || expCt !== ''}
                  value={expCntr}
                >
                  <option value=''>Please Select Country</option>
                  {countries
                    .filter((c) => c.region === 'country')
                    .sort((a, b) => a.cntry_name.localeCompare(b.cntry_name))
                    .map((cntr, index) => {
                      return (
                        <option key={index} value={cntr.cntry_code}>
                          {cntr.cntry_name}
                        </option>
                      );
                    })}
                </AvField>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup className='mb-3'>
                <AvField
                  type='select'
                  name='expSt'
                  className='form-select'
                  label='By State'
                  onChange={handleFilterChange}
                  disabled={expDef !== '' || expCont !== '' || expCntr !== '' || expCt !== ''}
                  value={expSt}
                >
                  <option value=''>Please Select State</option>
                  {countries
                    .filter((c) => c.region === 'state')
                    .sort((a, b) => a.cntry_name.localeCompare(b.cntry_name))
                    .map((cntr, index) => {
                      return (
                        <option key={index} value={cntr.cntry_code}>
                          {cntr.cntry_name}
                        </option>
                      );
                    })}
                </AvField>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup className='mb-3'>
                <AvField
                  type='select'
                  name='expCt'
                  className='form-select'
                  label='By City'
                  onChange={handleFilterChange}
                  disabled={expDef !== '' || expCont !== '' || expCntr !== '' || expSt !== ''}
                  value={expCt}
                >
                  <option value=''>Please Select City</option>
                  {countries
                    .filter((c) => c.region === 'city')
                    .sort((a, b) => a.cntry_name.localeCompare(b.cntry_name))
                    .map((cntr, index) => {
                      return (
                        <option key={index} value={cntr.cntry_code}>
                          {cntr.cntry_name}
                        </option>
                      );
                    })}
                </AvField>
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <div className='text-center font-size-18 mt-2 mb-5'>
            <b>Additional Filters</b>
          </div>
          <Row>
            <Col md={12}>
              <FormGroup className='mb-3'>
                <AvField
                  type='select'
                  name='expLng'
                  className='form-select'
                  label='Region Language'
                  value={expLng}
                  onChange={handleFilterChange}
                  validate={{
                    required: {
                      value: true
                    }
                  }}
                >
                  <option value=''>Please Select Region Language</option>
                  {languages.map((lng, index) => {
                    return (
                      <option key={index} value={lng.lng_code}>
                        {lng.lng_name}
                      </option>
                    );
                  })}
                </AvField>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup className='mb-3'>
                <AvField type='select' name='expCat' className='form-select' label='Select Category' onChange={handleFilterChange} multiple size={categories.length} value={order.categories}>
                  {categories &&
                    categories.map((category, index) => {
                      const isExcluded = excludedCategoryIds.includes(category._id);
                      return (
                        <option value={category._id} key={index} disabled={isExcluded}>
                          {category.catNameLng?.catName} {isExcluded ? ' (COMING SOON)' : ''}
                        </option>
                      );
                    })}
                </AvField>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className='mt-5 font-size-18'>
                <AvCheckboxGroup name='includeWAmount'>
                  <AvCheckbox label='Include Wholesale Price' checked={includeWAmountChecked} onChange={handleAssProductsChange} />
                </AvCheckboxGroup>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className='mt-5 font-size-18'>
                <AvCheckboxGroup name='includeWAmountAdd'>
                  <AvCheckbox label='Include Add Wh Price' checked={includeWAmountAddChecked} onChange={handleAssProductsChange} />
                </AvCheckboxGroup>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className='mt-5 font-size-18'>
                <AvCheckboxGroup name='assProducts'>
                  <AvCheckbox label='Download Assortment Products' checked={assProductsChecked} onChange={handleAssProductsChange} />
                </AvCheckboxGroup>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup className='mt-5 font-size-18'>
                <AvCheckboxGroup name='noAssProducts'>
                  <AvCheckbox label='Exclude Assortment Products' checked={noAssProductsChecked} onChange={handleAssProductsChange} />
                </AvCheckboxGroup>
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      <hr />
    </>
  );
  console.log(selectedCountry);
  const modalPaymentLinkContent = (
    <>
      <Row>
        <Col md={1}></Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField name='invoiceNo' label='Order Request No' type='text' autoComplete='off' value={order.invoiceNo} readOnly />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              type='select'
              name='manager'
              id='manager'
              className='form-select'
              label='Manager'
              errorMessage='Please select manager'
              validate={{
                required: {
                  value: true,
                  errorMessage: 'Please select manager'
                }
              }}
              value={Object.keys(order).length === 1 && order.hasOwnProperty('invoiceNo') ? profileData._id + '|' + profileData.bitrixID : order?.manager?._id + '|' + order?.manager?.bitrixID}
            >
              {managers.map((manager) => {
                return (
                  <option key={manager._id} value={manager._id + '|' + manager.bitrixID}>
                    {manager.fname} {manager.sname}
                  </option>
                );
              })}
            </AvField>
          </FormGroup>
        </Col>
        <Col md={2}></Col>
      </Row>
      <hr />
      <Row>
        <Col md={1}></Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='clientFName'
              label='Client First Name'
              type='text'
              autoComplete='off'
              value={order.clientFName}
              validate={{
                required: {
                  value: true
                }
              }}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='clientSName'
              label='Client Last Name'
              type='text'
              autoComplete='off'
              value={order.clientSName}
              validate={{
                required: {
                  value: true
                }
              }}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='email'
              label='Email'
              type='email'
              autoComplete='off'
              validate={{
                required: {
                  value: true
                }
              }}
              value={order.email}
            />
          </FormGroup>
        </Col>
        <Col md={2}></Col>
      </Row>
      <Row>
        <Col md={1}></Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='clientName'
              label='Company'
              type='text'
              autoComplete='off'
              placeholder='Leave empty to use client first and last name'
              validate={{
                required: {
                  value: true
                }
              }}
              value={order.clientName}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='link'
              label='Link'
              type='link'
              autoComplete='off'
              validate={{
                required: {
                  value: true
                }
              }}
              value={order.link}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <Label htmlFor='country'>Country</Label>
            <Dropdown
              placeholder='Select Country'
              fluid
              search
              selection
              options={countryOptions}
              name='country'
              defaultValue={selectedCountry}
              onChange={(e, data) => handleInputChange(data.value)}
              id='country'
            />
          </FormGroup>
        </Col>
        {selectedCountry === 'us' && (
          <Col md={2}>
            <FormGroup className='mb-3'>
              <Label htmlFor='state'>State</Label>
              <Dropdown
                placeholder='Select State'
                fluid
                search
                selection
                options={usStateOptions}
                name='state'
                defaultValue={selectedCountry}
                onChange={(e, data) => handleStateChange(data.value)}
                id='state'
              />
            </FormGroup>
          </Col>
        )}
      </Row>
      <Row>
        <Col md={1}></Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='oneCNo'
              label='Name and Order # from ERP'
              type='text'
              autoComplete='off'
              validate={{
                required: {
                  value: true
                }
              }}
              value={order.oneCNo}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              name='invoiceSum'
              label='Invoice Sum'
              type='number'
              autoComplete='off'
              validate={{
                required: {
                  value: true
                }
              }}
              value={order.invoiceSum || (order.orderInfo && order.orderInfo.reduce((sum, item) => sum + item.totalPrice, 0))}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup className='mb-3'>
            <AvField
              type='select'
              name='currencyReq'
              id='currencyReq'
              className='form-select'
              label='Currency'
              errorMessage='Please select currency'
              validate={{
                required: {
                  value: true,
                  errorMessage: 'Please select currency'
                }
              }}
            >
              <option value='EUR'>EUR</option>
              <option value='GBP'>GBP</option>
              <option value='USD'>USD</option>
              <option value='JPY'>JPY</option>
              <option value='CAD'>CAD</option>
              <option value='AUD'>AUD</option>
              <option value='AED'>AED</option>
              <option value='MXN'>MXN</option>
              <option value='SGD'>SGD</option>
              <option value='HKD'>HKD</option>
            </AvField>
          </FormGroup>
        </Col>
        <Col md={2}></Col>
      </Row>
      <Row>
        <Col md={3}></Col>
        <Col md={6}>
          <Dropzone accept='.jpeg,.jpg,.png,.pdf' onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
            {({ getRootProps, getInputProps }) => (
              <div className='dropzone'>
                <div className='dz-message needsclick' {...getRootProps()}>
                  <input {...getInputProps()} />
                  <div className='mb-3'>
                    <i className='display-4 text-muted bx bxs-cloud-upload' />
                  </div>
                  <h4>Drop files here or click to upload.</h4>
                </div>
              </div>
            )}
          </Dropzone>
        </Col>
        <Col md={3}></Col>
      </Row>
      <hr />
    </>
  );

  const orderOptions = [
    { key: false, label: 'Order Links', icon: <Link2 size={22} className='ms-3 pe-2' />, colorClass: 'bg-primary' },
    { key: true, label: 'Payment Requests', icon: <Banknote size={22} className='ms-3 pe-2' />, colorClass: 'bg-primary' }
  ];
  const [showOrderStatusAlert, setShowOrderStatusAlert] = useState(false);
  const columns = [
    {
      text: 'ID',
      dataField: '_id',
      sort: true,
      editable: false,
      formatter: (cell, row, rowIndex) => rowIndex + 1
    },
    {
      text: 'Order Request No',
      dataField: 'invoiceNo',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, order) => (
        <div>
          <h5 className='font-size-16 mb-1'>{order.clientName}</h5>
          <p className='text-muted mb-0'>#{order.invoiceNo}</p>
        </div>
      )
    },
    {
      text: 'Order Details',
      dataField: 'currency',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, order) => {
        // assuming categories is available in scope
        const selectedCatNames = Array.isArray(order?.categories)
          ? order.categories.length === 0
            ? ['All']
            : order.categories
                .map((catId) => {
                  const found = categories?.find((cat) => cat._id === catId);
                  return found?.catNameLng?.catName ?? null;
                })
                .filter(Boolean)
          : [];
        return (
          <div className='p-2'>
            <p className='text-muted mb-0'>
              Currency: <b>{order.currency === 'usd' || order.currency === 'eur' ? '$' + order.currency : order.currency}</b>
            </p>
            <p className='text-muted mb-0'>
              Region: <b>{order.country !== '' ? countries.find((reg) => reg.cntry_code === order.country)?.cntry_name : 'World'}</b>
            </p>
            <p className='text-muted mb-0'>
              Language: <b>{languages.find((lang) => lang.lng_code === order.language)?.lng_name}</b>
            </p>
            <p className='text-muted mb-0'>
              Include Wholesale Prices: <b>{order.includeWPrice ? 'Yes' : 'No'}</b>
            </p>
            <p className='text-muted mb-0'>
              Include Additional Wholesale Prices: <b>{order.includeAddWPrice ? 'Yes' : 'No'}</b>
            </p>
            <p className='text-muted mb-0'>
              Categories Selected: <b>{selectedCatNames.join(', ')}</b>
            </p>
            <p className='text-muted mb-0'>
              Display Assortment Products: <b>{order.excludeAssProducts ? 'No' : 'Yes'}</b>
            </p>
          </div>
        );
      }
    },
    {
      text: 'Order Link',
      dataField: 'clientName',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, order) => (
        <div className='pb-4'>
          <h5 className='font-size-16 mb-1 d-flex align-items-left'>
            <span className='d-inline-flex align-items-left'>
              <strong>#{order.invoiceNo}</strong>
              <a href={`https://koru-ms.com/catalog/${btoa(order._id)}`} target='_blank' rel='noopener noreferrer' className='ms-2 me-2 d-flex align-items-center'>
                <ExternalLink size={16} />
              </a>
              <Copy
                size={18}
                color='#497ea7'
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.stopPropagation();

                  const htmlToCopy = `Hello,
Here is the link for your order:
<a href="https://koru-ms.com/catalog/${btoa(order._id)}"> https://koru-ms.com/catalog/${btoa(order._id)}</a>

Please use it to create and order.

<b>Please note that you can edit your order request before the final confirmation with the manager.</b>

Thank you`;
                  if (navigator.clipboard && window.ClipboardItem) {
                    const blobInput = new ClipboardItem({
                      'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
                      'text/plain': new Blob([htmlToCopy.replace(/<[^>]+>/g, '')], { type: 'text/plain' })
                    });

                    navigator.clipboard
                      .write([blobInput])
                      .then(() => showToast('success', 'Copied to clipboard'))
                      .catch(() => showToast('error', 'Failed to copy'));
                  } else {
                    // Fallback for older/HTTP browsers
                    const textarea = document.createElement('textarea');
                    textarea.value = htmlToCopy.replace(/<[^>]+>/g, ''); // strip HTML for plain text copy
                    textarea.style.position = 'fixed';
                    textarea.style.opacity = 0;
                    document.body.appendChild(textarea);
                    textarea.select();

                    try {
                      if (document.execCommand('copy')) {
                        showToast('success', 'Copied to clipboard');
                      } else {
                        showToast('error', 'Failed to copy');
                      }
                    } catch (err) {
                      showToast('error', 'Failed to copy');
                    }

                    document.body.removeChild(textarea);
                  }
                }}
              />
            </span>
          </h5>
        </div>
      )
    },
    {
      text: 'Payment Details',
      dataField: 'oneCNo',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, order) => {
        return (
          <div className='p-2'>
            <p className='text-muted mb-0'>
              Sender: <b>{order.clientName}</b>
            </p>
            <p className='text-muted mb-0'>
              Website: <b>{order.link}</b>
            </p>
            <p className='text-muted mb-0'>
              Client Name:{' '}
              <b>
                {order.clientFName} {order.clientSName}
              </b>
            </p>
            <p className='text-muted mb-0'>
              Email: <b>{order.email}</b>
            </p>
            <p className='text-muted mb-0'>
              Country: <b>{order.country}</b>
              {/* Country: <b>{order.country && getCountryName(order)}</b> */}
            </p>
            <p className='text-muted mb-0'>
              Invoice Sum: <b>{order.invoiceSum}</b>
            </p>
            <p className='text-muted mb-0'>
              Invoice Number: <b>{order.oneCNo}</b>
            </p>
          </div>
        );
      }
    },
    {
      text: 'Payment Request',
      dataField: 'paymentLink',
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, order) => (
        <div className='pb-4'>
          <h5 className='font-size-16 mb-1 d-flex align-items-left'>
            <span className='d-inline-flex align-items-left'>
              {order.paymentLink && (
                <>
                  <strong>Payment Request </strong>
                  <a href={order.paymentLink} target='_blank' rel='noopener noreferrer' className='ms-2 me-2 d-flex align-items-center'>
                    <ExternalLink size={16} />
                  </a>
                  <Copy
                    size={18}
                    color='#497ea7'
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                      e.stopPropagation();

                      const htmlToCopy = `Hello,
    Here is the link for your payment:
    <a href="${order.paymentLink}"> ${order.paymentLink}</a>

    Thank you`;
                      if (navigator.clipboard && window.ClipboardItem) {
                        const blobInput = new ClipboardItem({
                          'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
                          'text/plain': new Blob([htmlToCopy.replace(/<[^>]+>/g, '')], { type: 'text/plain' })
                        });

                        navigator.clipboard
                          .write([blobInput])
                          .then(() => showToast('success', 'Copied to clipboard'))
                          .catch(() => showToast('error', 'Failed to copy'));
                      } else {
                        // Fallback for older/HTTP browsers
                        const textarea = document.createElement('textarea');
                        textarea.value = htmlToCopy.replace(/<[^>]+>/g, ''); // strip HTML for plain text copy
                        textarea.style.position = 'fixed';
                        textarea.style.opacity = 0;
                        document.body.appendChild(textarea);
                        textarea.select();

                        try {
                          if (document.execCommand('copy')) {
                            showToast('success', 'Copied to clipboard');
                          } else {
                            showToast('error', 'Failed to copy');
                          }
                        } catch (err) {
                          showToast('error', 'Failed to copy');
                        }

                        document.body.removeChild(textarea);
                      }
                    }}
                  />

                </>
              )}
            </span>
          </h5>
          <strong style={{ display: 'block' }}>{order.paymentRequestId}</strong>
          <strong style={{ display: 'block' }}>{order.paymentStatus}</strong>
        </div>
      )
    },
    {
      text: 'Manager',
      dataField: 'manager.workEmail',
      csvExport: true,
      sort: true,
      editable: false,
      formatter: (cellContent, order) => (
        <div className='slname-width'>
          <h5 className='font-size-16 mb-1'>
            <span>
              <div>
                {!order.manager.profilePic ? (
                  <div className='avatar-sm m-2 d-inline-block'>
                    <span className='avatar-title rounded-circle'>{order.manager.fname.charAt(0)}</span>
                  </div>
                ) : (
                  <img className='rounded-circle avatar-sm m-2' src={order.manager.profilePic} alt='profile pic' />
                )}
                <span>
                  {order.manager.fname}
                  &nbsp;
                  {order.manager.sname}
                </span>
              </div>
            </span>
          </h5>
        </div>
      )
    },
    {
      dataField: 'menu',
      isDummyField: true,
      editable: false,
      text: 'Action',
      formatter: (cellContent, order) => (
        <div className='d-flex gap-3'>
          <Link className='text-warning' to='#'>
            <i className='mdi mdi-pencil font-size-18' onClick={() => handleEditOrderClick(order)}></i>
          </Link>
          {order.orderInfo && (
            <>
              <Link className='text-primary' to='#'>
                <i className='mdi mdi-receipt font-size-18' onClick={() => handleViewOrderInfo(order)}></i>
              </Link>
              <Link className='text-primary' to='#'>
                <i
                  className={order.orderStatus ? 'mdi mdi-checkbox-marked-circle-outline font-size-18' : 'mdi mdi-checkbox-blank-circle-outline font-size-18'}
                  onClick={() => handleOrderComplete(order)}
                ></i>
              </Link>
              <Link className={`text-success ${!order.orderStatus ? 'disabled-link' : ''}`} to='#'>
                <i
                  className='mdi mdi-cash-multiple font-size-18'
                  onClick={(e) => {
                    e.preventDefault();
                    if (!order.orderStatus) {
                      setShowOrderStatusAlert(true);
                    } else {
                      handleNewPaymentClick(e, order);
                    }
                  }}
                ></i>
              </Link>
            </>
          )}
          <Link className='text-danger' to='#'>
            <i className='mdi mdi-delete font-size-18' id='deletetooltip' onClick={() => handleDeleteOrderClick(order)}></i>
          </Link>
        </div>
      )
    }
  ];
  const defaultSorted = [
    {
      dataField: 'date',
      order: 'asc'
    }
  ];
  return (
    <React.Fragment>
      <PageLoader progress={progress} step={step} visible={visible} />
      <div className='page-content'>
        <MetaTags>
          <title>Client Orders & Payments</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title='Price List' breadcrumbItem='Client Orders & Payments' />
          <Row className='card-section'>
            <Col lg='12'>
              <div className='pcss3t logtb pcss3t-effect-scale pcss3t-theme-1'>
                <ul>
                  <AnimatePresence key='1' exitBeforeEnter>
                    <motion.li
                      className={`tab-content tab-content-1 typography`}
                      initial={{ opacity: 0, x: 30 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -30 }}
                      transition={{ duration: 0.3 }}
                      style={{ display: 'block' }}
                    >
                      <div id='card-section' ref={cardRef}>
                        <Row className='card-section'>
                          <Col lg='12'>
                            <Card>
                              <CardBody className='cardBodySticky'>
                                <ToolkitProvider keyField='_id' columns={columns} data={filteredOrders ? filteredOrders : orders} search>
                                  {(props) => (
                                    <React.Fragment>
                                      <MainContent
                                        page={{
                                          pg: 'client_orders',
                                          props: props,
                                          cardHeight,
                                          showSearch: true,
                                          showCSV: true,
                                          showInTblFltr: true,
                                          showDbFilter: false,
                                          showSwitch: true,
                                          showBtn: true,
                                          showScndBtn: true,
                                          columns: props.baseProps.columns,
                                          data: props.baseProps.data,
                                          defaultSorted,
                                          rowClasses: rowClasses
                                        }}
                                        myOrdersOptions={{
                                          isChecked: isChecked,
                                          setChecked: setChecked,
                                          showAllOrders: showAllOrders
                                        }}
                                        // filter options
                                        filterOptions={{ orderTypes: orderOptions }}
                                        // filterDbOptions={{filterFormValues} }
                                        setNoDbFilters={setNoDbFilters}
                                        // options for adding/updating modal and button
                                        btnCrtModalOptions={{
                                          btnLabelCrt: 'Generate New Order Link',
                                          btnIcon: 'mdi mdi-link-variant-plus me-1',
                                          modalSize: 'xl',
                                          modalTitle: isEdit ? 'Edit Order Link' : 'Generate New Order Link',
                                          modalBtnLabel: isEdit ? 'Edit Order Link' : 'Generate New Order Link',
                                          modalAdd: modalOrder,
                                          toggleAddModal: toggleOrderModal,
                                          handleNewClick: handleNewOrderClick,
                                          modalContent: modalNewOrderContent,
                                          handleSubmit: handleNewOrderSubmit
                                        }}
                                        btnCrtScndModalOptions={{
                                          btnLabelCrtScnd: 'Generate New Payment Request',
                                          btnColorScnd: 'success',
                                          btnIconScnd: 'mdi mdi-cash-multiple me-1',
                                          modalSizeScnd: 'xl',
                                          modalTitleScnd: isEdit ? 'Edit Payment Request' : 'Generate New Payment Request',
                                          modalBtnLabelScnd: isEdit ? 'Edit Payment Request' : 'Generate New Payment Request',
                                          modalAddScnd: modalPayment,
                                          toggleAddModalScnd: togglePaymentModal,
                                          handleNewClickScnd: handleNewPaymentClick,
                                          modalContentScnd: modalPaymentLinkContent,
                                          handleSubmitScnd: handleNewPaymentLinkSubmit,
                                          errorMsgScnd: error
                                        }}
                                        // table data opotions
                                        tableOptions={{ includeSelect: false, manualColumnWidthsIndex: [1], manualColumnWidths: [130] }}
                                      />
                                      <BtnModal
                                        modalSize='xl'
                                        modalTitle={`Order Information ${order.invoiceNo}`}
                                        modalBtnLabel='Copy'
                                        modalOpen={modalInfo}
                                        toggleModal={toggleOrderInfoModal}
                                        handleSubmit={copyToClipboard}
                                      >
                                        {modalInfoContent}
                                      </BtnModal>
                                      <SweetAlert
                                        show={showDeleteAlert}
                                        danger
                                        showCancel
                                        confirmBtnText='Yes, delete it!'
                                        confirmBtnBsStyle='danger'
                                        title='Are you sure?'
                                        onConfirm={handleDeleteOrder}
                                        onCancel={() => setShowDeleteAlert(false)}
                                        focusCancelBtn
                                      >
                                        <p>
                                          The order <span className='fw-bold'>#{order.invoiceNo}</span> will be deleted from the system!
                                        </p>{' '}
                                      </SweetAlert>
                                      {showOrderStatusAlert && (
                                        <SweetAlert
                                          title={
                                            <div className='text-center'>
                                              <h2 className='fw-bold'>Please complete the order status first.</h2>
                                              <i className='text-primary mdi mdi-checkbox-blank-circle-outline font-size-22'></i>
                                              <i className='mdi mdi-arrow-right-bold font-size-18'></i>

                                              <i className='text-primary mdi mdi-checkbox-marked-circle-outline font-size-22'></i>
                                            </div>
                                          }
                                          onConfirm={() => setShowOrderStatusAlert(false)}
                                        ></SweetAlert>
                                      )}
                                    </React.Fragment>
                                  )}
                                </ToolkitProvider>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </motion.li>
                  </AnimatePresence>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
